var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 47.5,
    r: 46.5,
    stroke: "#20C55D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3266 53.5954C42.8838 54.0209 42.184 54.0207 41.7415 53.595L36.5776 48.6278C35.9315 48.0063 34.9104 48.0045 34.2622 48.6237C33.5739 49.2811 33.572 50.3794 34.2579 51.0392L41.5486 58.0523C42.0988 58.5815 42.9689 58.5815 43.5191 58.0523L61.7507 40.515C62.4327 39.8589 62.4327 38.7675 61.7507 38.1114C61.1053 37.4907 60.0849 37.4904 59.4393 38.1109L43.3266 53.5954Z",
    fill: "#20C55D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/message_success.143848fa63cc9323ca7b5866bdec7a6d.svg";